module.exports = __webpack_public_path__ + "img/logo6.a41abc40.png";